(() => {
  // app/scripts/cart-discount-noti.js
  if (!customElements.get("cart-discount-noti")) {
    class CartDiscountNoti extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.discountAppliedHandler = (e) => {
          if (!e || !e.cart || typeof e.discounts != "object") return;
          const notiContainer = this.closest(".sb-cart-discount-noti");
          if (e.discounts.length >= 2) {
            notiContainer.classList.remove("hidden");
          } else {
            notiContainer.classList.add("hidden");
          }
        };
        document.body.addEventListener("docapp-discount-applied", this.discountAppliedHandler);
      }
      disconnectedCallback() {
        document.body.removeEventListener("docapp-discount-applied", this.discountAppliedHandler);
      }
    }
    customElements.define("cart-discount-noti", CartDiscountNoti);
  }
})();
